export const routes = Object.freeze({
  home: "/",
  about: "/about",
  services: "/services",
  training: "/training",
  hireFTO: "/hire_FCTO",
  contact_us: "/contact_us",
});
